import React from 'react';
import PropTypes from 'prop-types';
import {
  TypographyHeaderWithLineStyled,
} from './styles';

export const HeaderWithLineComponent = ({
  centeredLine,
  className,
  headerText,
}) => (
  <TypographyHeaderWithLineStyled
      className={className}
      component="h3"
      variant="h6"
      centeredLine={centeredLine}>
    {headerText}
  </TypographyHeaderWithLineStyled>
);

HeaderWithLineComponent.propTypes = {
  centeredLine: PropTypes.bool,
  className: PropTypes.string,
  headerText: PropTypes.string.isRequired,
};

export default HeaderWithLineComponent;
